import { Box } from '@mui/material';
import { formatShort } from '../utils/dates';
import StatCard from './StatCard';

/** The Calendar view's headline row for the month (see utils/hours `monthStats`). */
export default function CalendarStats({ stats }) {
  const { average, workingDays, overloadDays, busiest, lightest } = stats;

  return (
    <Box display="grid" gridTemplateColumns={{ xs: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(4, minmax(0, 1fr))' }} gap={2} sx={{ mt: 3 }}>
      <StatCard label="Average utilisation" value={`${Math.round(average)}%`} note={`Across ${workingDays} working days`} />
      <StatCard label="Days with overload" value={overloadDays} note="At least one person over 100%" level="overloaded" />
      <StatCard
        label="Busiest day"
        value={busiest ? `${Math.round(busiest.pct)}%` : '-'}
        note={busiest ? `${formatShort(busiest.day)} · ${busiest.levels.overloaded} people overloaded` : 'No working days'}
        level="atCapacity"
      />
      <StatCard
        label="Lightest day"
        value={lightest ? `${Math.round(lightest.pct)}%` : '-'}
        note={lightest ? `${formatShort(lightest.day)} · ${lightest.levels.available} people available` : '-'}
        level="available"
      />
    </Box>
  );
}
